import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getUnderlyingLiveFeedUnderlyingData } from '../../../../stores/underlying-live-feed/getters';
import { dateMoment } from '../../../../utils';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    lineHeight: '16.9px',
    marginLeft: 6,
    color: 'var(--color-expiry-pill-color)',
    fontWeight: 700,
    textTransform: 'uppercase',
    backgroundColor: 'var(--color-expiry-pill-bg)',
    height: 16,
    width: 55,
    borderRadius: '3px',
  },
}));

function useIsExpired(expiryDate) {
  if (!expiryDate) {
    return false;
  }

  const today = dateMoment();
  const expiryDateMoment = dateMoment(expiryDate);

  if (expiryDateMoment.isSameOrBefore(today)) {
    return true;
  }

  return false;
}

const ExpiryPill = ({ symbol = '' }) => {
  const classes = useStyles();
  const expiryDate = useSelector((state) => {
    const value = getUnderlyingLiveFeedUnderlyingData(state);

    const { expiryDate } = value[symbol] ? value[symbol] : {};

    return expiryDate;
  });
  const isExpired = useIsExpired(expiryDate);

  if (!isExpired) {
    return;
  }

  return <span className={`${classes.root} ExpiryPill`}>Expiry</span>;
};

export default ExpiryPill;
